import { render } from "./ChallengeResultsStats.vue?vue&type=template&id=0a8bfc70&scoped=true"
import script from "./ChallengeResultsStats.vue?vue&type=script&lang=js"
export * from "./ChallengeResultsStats.vue?vue&type=script&lang=js"

import "@/css/components/challenge-results-stats.css?vue&type=style&index=0&id=0a8bfc70&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8bfc70"]])

export default __exports__